var idemState = {
  keys: [],
};

/**
 * Generates a cryptographically strong UUID v4–style idempotency key.
 * @param {string} [prefix] - Optional prefix (e.g. 'payment', 'order', etc.)
 * @returns {string} - A UUID-style idempotency key.
 */
function generateKey(prefix = "") {
  // Create 16 random bytes
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // Set version and variant bits according to RFC 4122
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xxxxxx

  // Convert to hex and format as UUID
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join(
    "",
  );
  const uuid = [
    hex.substring(0, 8),
    hex.substring(8, 12),
    hex.substring(12, 16),
    hex.substring(16, 20),
    hex.substring(20),
  ].join("-");

  // testing
  //return "identity_a977bf3c-628a-4779-9f6a-3846ace72bb9";
  const key = prefix ? `${prefix}_${uuid}` : uuid;
  idemState.keys.push(key);
  return key;
}

const keyExists = (key) => {
  if (idemState.keys.includes(key)) {
    return true;
  } else {
    return false;
  }
};

export const idem = {
  generateKey,
  keyExists,
};
